'use client';

import React from 'react';
import { Box, Text } from '@skin-seoul/design-system';
import LucideIcon from '../LucideIcon';
export interface DropdownTriggerProps {
  selectedValue: string;
  isOpen: boolean;
  onClick: () => void;
  disabled?: boolean;
  placeholder?: string;
}
const DropdownTrigger = ({
  selectedValue,
  isOpen,
  onClick,
  disabled = false,
  placeholder = 'Select an option'
}: DropdownTriggerProps) => {
  return <Box as="button" width="100%" height="44px" backgroundColor="neutral.50" color="neutral.700" borderRadius="8px" paddingX={4} paddingY={3} border="none" textAlign="left" cursor={disabled ? 'not-allowed' : 'pointer'} opacity={disabled ? 0.5 : 1} _hover={!disabled ? {
    backgroundColor: 'neutral.100'
  } : {}} _focus={!disabled ? {
    backgroundColor: 'neutral.100',
    boxShadow: 'none'
  } : {}} onClick={disabled ? undefined : onClick} display="flex" alignItems="center" justifyContent="space-between" data-sentry-element="Box" data-sentry-component="DropdownTrigger" data-sentry-source-file="DropdownTrigger.tsx">
      <Text textStyle="label.large" fontWeight="normal" color={selectedValue ? 'neutral.700' : 'neutral.400'} data-sentry-element="Text" data-sentry-source-file="DropdownTrigger.tsx">
        {selectedValue || placeholder}
      </Text>

      <Box transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'} transition="transform 0.2s" display="flex" alignItems="center" justifyContent="center" width="20px" height="20px" data-sentry-element="Box" data-sentry-source-file="DropdownTrigger.tsx">
        <LucideIcon name="ChevronDown" size="md" data-sentry-element="LucideIcon" data-sentry-source-file="DropdownTrigger.tsx" />
      </Box>
    </Box>;
};
export default DropdownTrigger;